<template>
  <v-touch @swipeleft="swiperleft" @swiperight="swiperight" class="frame">
    <div class="container-box">
      <!-- 顶部 -->
      <div class="header">
        <tabBar class="tabBarStyle"></tabBar>
      </div>
      <!-- 内容 -->
      <div class="content">
        <div class="headerChild">
          <video id="myVideo3" class="video-js" style="object-fit: cover">
            <source src="https://slkjkg.com/video/test.mp4" type="video/mp4" />
          </video>
        </div>
        <div class="tabBarFontFrame">
          <div class="tabBarFont">
            <span>{{ tabBarTitle }}</span>
          </div>
          <div class="tabBarFont1">
            <span>{{ tabBarTitle1 }}</span>
          </div>
        </div>
        <!-- 企业发展历程 -->
        <div class="developFrame">
          <div class="IntroduceTitle">
            <!-- <div class="IntroduceTitleBg"></div> -->
            <div class="IntroduceTitleFont">
              <div class="IntroduceTitleFontChild">
                <span style="letter-spacing: 0.5em">企业简介</span>
              </div>
              <div class="IntroduceTitleFontChild1">
                <img
                  src="../../assets/introduco-img.png"
                  style="
                    position: absolute;
                    bottom: 13px;
                    right: -15px;
                    width: 25px;
                    height: 25px;
                  "
                />

                <span>SHANLI ENTERPRISE PROFILE </span>
              </div>
            </div>
            <!-- <div class="IntroduceTitleBg"></div> -->
          </div>
          <div class="developFrameContent">
            <img src="../../assets/gs.jpg" style="height: 260px; width: 96%" />
          </div>
          <div
            class="introduceContentContent"
            style="
              padding-left: 10px;
              padding-right: 10px;
              padding-top: 10px;
              font-weight: 600;
            "
          >
            {{ introduceFont }}
          </div>
          <div class="IntroduceTitle">
            <!-- <div class="IntroduceTitleBg"></div> -->
            <div class="IntroduceTitleFont">
              <div class="IntroduceTitleFontChild">
                <span>企业发展历程</span>
              </div>
              <div class="IntroduceTitleFontChild1">
                <img
                  src="../../assets/introduco-img.png"
                  style="
                    position: absolute;
                    bottom: 13px;
                    right: -15px;
                    width: 25px;
                    height: 25px;
                  "
                />

                <span>ENTERPRISE DEVELOPMENT HISTORY</span>
              </div>
            </div>
            <!-- <div class="IntroduceTitleBg"></div> -->
          </div>
          <!-- 内容 -->
          <div class="developFrameContent">
            <!-- 插入 -->
            <div class="insertFrame">
              <div class="insertChildFrame"></div>
              <div class="circleGroup">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
            </div>
            <!-- 循环 -->
            <div class="developLoopFrame">
              <div
                class="developLoop"
                v-for="(item, index) in list"
                :key="index"
              >
                <div class="developLoopImg">
                  <img :src="item.url" class="imgStyle" />
                </div>
                <div class="developLoopTitle">
                  <span>{{ item.title }}年</span>
                </div>
                <div class="developLoopContent">
                  <span>{{ item.content }}</span>
                </div>
              </div>
              <div class="propaganda">
                <div class="propagandaChild">
                  <div class="propagandaChild1">
                    <span>未来</span>
                  </div>
                  <div class="propagandaChild2">
                    <span>我们将不断前行</span>
                  </div>
                  <div class="propagandaChild3">
                    <span>不断挑战</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 企业文化 -->
        <div class="corporateCulture">
          <div class="IntroduceTitle" style="margin: 20px 0">
            <!-- <div class="IntroduceTitleBg"></div> -->
            <div class="IntroduceTitleFont">
              <div
                
                style="
                  position: relative;
                  display: flex;
                  justify-content: center;
                  letter-spacing: 0.2rem;
                "
               
              >
                <span style="position: absolute; top: -15px; color: black;margin-left: 20px;" class="add">
                  <span style="font-size: 25px; font-weight: 600">未来</span
                  >,我们将不断前行，不断挑战
                </span>
                <svg width="280" height="40" xmlns="http://www.w3.org/2000/svg" class="add">
                  <line
                    x1="10"
                    y1="25"
                    x2="255"
                    y2="25"
                    stroke="black"
                    stroke-width="2"
                  />
                  <polygon points="255,20 265,25 255,30" fill="black" />
                </svg>
              </div>

              <div class="IntroduceTitleFontChild">
                <span>企业文化</span>
              </div>
              <div class="IntroduceTitleFontChild1">
                <img
                  src="../../assets/introduco-img.png"
                  style="
                    position: absolute;
                    bottom: 13px;
                    right: -15px;
                    width: 25px;
                    height: 25px;
                  "
                />

                <span>CORPORATE CULTURE</span>
              </div>
            </div>
            <!-- <div class="IntroduceTitleBg"></div> -->
          </div>
          <!-- 内容 -->
          <div class="corporateCultureContent">
            <div class="corporateCultureContentImg">
              <img src="../../assets/culture.png" class="imgStyle" />
            </div>
            <div class="corporateCultureContentImg1">
              <!-- 企业愿景 -->
              <div class="enterpriseVisionFrame">
                <div class="cultureFont">
                  <span>企业愿景</span>
                </div>
                <div class="cultureFont1">
                  <span>{{ enterpriseVision }}</span>
                </div>
              </div>
              <div class="cultureChild">
                <img src="../../assets/culture1.png" class="imgStyle" />
              </div>
              <!-- <div class="cultureChild1"></div> -->
            </div>
          </div>
        </div>
        <!-- 企业资质 -->
        <div class="qualifications">
          <div class="IntroduceTitle">
            <!-- <div class="IntroduceTitleBg"></div> -->
            <div class="IntroduceTitleFont">
              <div class="IntroduceTitleFontChild">
                <span style="letter-spacing: 0.5em">企业资质</span>
              </div>
              <div class="IntroduceTitleFontChild1">
                <img
                  src="../../assets/introduco-img.png"
                  style="
                    position: absolute;
                    bottom: 13px;
                    right: -15px;
                    width: 25px;
                    height: 25px;
                  "
                />
                <span>ENTERPRISE QUALIFICATION</span>
              </div>
            </div>
            <!-- <div class="IntroduceTitleBg"></div> -->
          </div>
          <!-- 内容 -->
          <div class="qualificationsContent">
            <!-- 社会责任 -->
            <div class="responsibility">
              <div class="responsibilityTitle">
                <span style="font-weight: 600">社会责任</span>
              </div>
              <div class="responsibilityImg">
                <img src="../../assets/active.png" class="imgStyle" />
              </div>
            </div>
            <!-- 政府关怀 -->
            <div class="governmentCare">
              <div class="governmentCareTitle">
                <span style="font-weight: 600">政府关怀</span>
              </div>
              <div class="governmentCareContent">
                <div class="governmentCareContentImg">
                  <div class="governmentCareContentImgChild">
                    <img
                      src="../../assets/qualifications1.png"
                      class="imgStyle"
                    />
                  </div>
                  <div class="governmentCareContentImgChild1">
                    <img
                      src="../../assets/qualifications2.png"
                      class="imgStyle"
                    />
                  </div>
                </div>
                <div class="governmentCareContentBg">
                  <div class="governmentCareContentFont">
                    <span>{{ governmentFont }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <fixedBottomRight></fixedBottomRight>
    </div>
  </v-touch>
</template>

<script>
import tabBar from "../../assembly/tabBarNew.vue";
import swiper from "../../assembly/mobileSwiper.vue";
import fixedBottomRight from "@/assembly/fixedBottomRight.vue";
export default {
  name: "introduce",
  data() {
    return {
      tabBarTitle: "",
      tabBarTitle1: "",
      introduceFont: `\xa0\xa0\xa0\xa0\xa0\xa0\xa0山哩数智科技有限公司（简称“山哩数智”）成立于2022年5月，是一家专注于个贷不良资产智能化运营的科技创新型企业。公司以“数智科技+大数据”为双引擎，为个贷不良资产提供全产业链管理服务。
公司自主研发的“E法通”智能系统，基于S2B2C案源供应链模式，集资产评估、智能分案与司法调解于一体，构建了覆盖全流程的数字化解决方案。
作为山哩控股集团的核心业务主体，山哩数智已完成全国化战略布局，控股河北、湖南、安徽、陕西、河南、江苏、广西等多家区域子公司，形成覆盖全国的规模化运营网络。`,
      enterpriseVision: "引领新消费、新经济、新业态;让中国新经济产业走向世界",
      governmentFont:
        "\xa0\xa0\xa0\xa0\xa0\xa0\xa0山哩科技的快速成长, 离不开党和国家的各项优惠政策, 更离不开各级政府领导的亲切关怀。公司成立以来各级政府领导多次对公司进行业务指导, 并对山哩科技的发展给予高度的肯定和赞赏, 鼓舞着山哩人乘风破浪勇往直前",
      list: [
        {
          url: require("@/assets/deve1.png"),
          title: "2013",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0项目以京东合伙人, 阿里生鲜、京东生鲜供应商的形式落地贵州毕节黔西。",
        },
        {
          url: require("@/assets/deve2.png"),
          title: "2014",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0京东生鲜正式纳入贵州项目, 正式启动京东黔西县特产馆。",
        },
        {
          url: require("@/assets/deve3.png"),
          title: "2015",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0项目成功获得西南地区阿里、京东生鲜的唯一供应商。",
        },
        {
          url: require("@/assets/deve4.png"),
          title: "2016",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0正式与黔西县人民政府签署战略合作, 成立好农哥生态农业有限公司",
        },
        {
          url: require("@/assets/deve5.png"),
          title: "2017",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0山哩优品品牌发起, 累计销售额突破20亿元, 细分赛道国内前三名",
        },
        {
          url: require("@/assets/deve6.png"),
          title: "2018",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa02018年7月山哩优品电商品牌正式与京东脱离",
        },
        {
          url: require("@/assets/deve7.png"),
          title: "2019",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0独立运营, 寻求合作伙伴, 以最佳的现货交易模式做全国顶尖的订单农业电商品牌",
        },
        {
          url: require("@/assets/deve8.png"),
          title: "2020",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0通过VIE架构在美国纳斯达克上市。山哩成为该年度以SPAC主板上市企业",
        },
        {
          url: require("@/assets/deve9.png"),
          title: "2021",
          content:
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0完成了A轮的3亿元人民币融资, 开启了向纳斯达克主板上市之路",
        },
      ],
    };
  },
  components: {
    tabBar,
    swiper,
    fixedBottomRight,
  },
  mounted() {
    this.initVideo();
    window.addEventListener("scroll", this.handleScroll); // 在挂载后监听滚动事件
    window.addEventListener("scroll", this.handleScroll1); // 在挂载后监听滚动事件
    
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll); // 在销毁前移除滚动事件
    window.removeEventListener("scroll", this.handleScroll1); // 在销毁前移除滚动事件
  },
  methods: {
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop; // 获取滚动距离
      let elements = document.querySelectorAll('.add');
      elements.forEach(div => {
        let offsetTop = div.getBoundingClientRect().top + window.scrollY; // 获取元素距离顶部的位置
        let threshold = 0; // 获取元素对应的阈值
        if (scrollTop + window.innerHeight > offsetTop + threshold) { // 判断元素是否进入可视区域
          if (!div.classList.contains('animation')) { // 如果不存在动画类，则添加
            div.classList.add('animation');
          }
        }
      });
    },
    handleScroll1() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop; // 获取滚动距离
      let elements = document.querySelectorAll('.developLoopFrame');
      elements.forEach(div => {
        let offsetTop = div.getBoundingClientRect().top + window.scrollY; // 获取元素距离顶部的位置
        let threshold = 0; // 获取元素对应的阈值
        if (scrollTop + window.innerHeight > offsetTop + threshold) { // 判断元素是否进入可视区域
          if (!div.classList.contains('animation1')) { // 如果不存在动画类，则添加
            div.classList.add('animation1');
          }
        }
      });
    },
    swiperleft() {
      /* this.$router.push({
					name: 'cooperation'
				}) */
    },
    swiperight() {
      /* this.$router.push({
					name: 'index'
				}) */
    },
    clickImg() {
      window.location.href =
        "https://mbd.baidu.com/newspage/data/videolanding?nid=sv_14798706679523612252";
    },
    initVideo() {
      //初始化视频方法
      let myPlayer = this.$video(myVideo3, {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        //自动播放属性,muted:静音播放
        autoplay: "muted",
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        //设置视频播放器的显示宽度（以像素为单位）
        width: "100px",
        //设置视频播放器的显示高度（以像素为单位）
        height: "100px",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
@keyframes show-text {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
/* 设置文本容器的样式 */
.animation {
  overflow: hidden; /* 隐藏溢出的文本 */
  white-space: nowrap; /* 不换行 */
}
/* 应用动画 */
.animation {
  display: inline-block;
  animation: show-text 2s ease-in-out;
  animation-fill-mode: forwards; /* 停留在最后状态 */
}

/* 应用动画 */
.animation1 {
  animation: show-text1 2s ease-in-out;
  animation-fill-mode: forwards; /* 停留在最后状态 */
}
@keyframes show-text1 {
		from {
			transform: translateY(100%);
			opacity: 0;
		}

		to {
			transform: translateY(0);
			opacity: 1;
		}
	}
.frame {
  position: absolute;
  height: 100%;
  width: 100%;
  touch-action: pan-y !important;
}

.container-box {
  display: flex;
  flex-direction: column;

  .imgStyle {
    height: 100%;
    width: 100%;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: fixed;
    background-color: #fff;
    height: 7.5vh;
    width: 100%;
    z-index: 999;
    opacity: 0.85;
    .headerChild {
      height: 59%;
      width: 100vw;
    }

    .tabBarFontFrame {
      pointer-events: none;
      color: #fff;
      height: 5vh;
      width: 100%;
      position: absolute;
      top: 24vh;
      z-index: 3;
      display: flex;
      align-items: center;
      flex-direction: column;

      .tabBarFont {
        letter-spacing: 2px;
        font-weight: bold;
        font-size: 1.3rem;
      }

      .tabBarFont1 {
        margin-top: 2%;
        font-size: 1rem;
        letter-spacing: 2px;
      }
    }
  }

  .content {
    margin-top: 7.5vh;
    width: 100vw;

    // 企业介绍
    .introduceContent {
      display: flex;
      flex-direction: column;

      .introduceContentImg {
        height: 25vh;
        margin: 1rem;
        margin-bottom: 10px;
      }

      .introduceContentTitle {
        height: 1.6vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 1rem 1.5rem;
        margin-left: 1rem;
        border-left: #7b0000 solid 10px;

        .contentFont {
          font-size: 1.5rem;
          font-weight: bold;
        }

        .contentFont1 {
          letter-spacing: 1px;
          font-size: 0.8rem;
        }
      }

      .introduceContentContent {
        margin: 1rem;
        font-size: 0.85rem;
        letter-spacing: 1px;
        font-weight: bold;
        display: flex;
        flex-wrap: wrap;
      }
    }

    // 企业发展历程
    .developFrame {
      display: flex;
      flex-direction: column;

      .developFrameContent {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;

        // 插入
        .insertFrame {
          margin-top: 1rem;
          position: absolute;
          display: flex;
          justify-content: center;
          margin-left: 1rem;
          width: 60%;
        }

        .insertChildFrame {
          width: 0.3rem;
          background-color: #7b0000;
        }

        .circleGroup {
          left: -0.63rem;
          position: relative;
          display: flex;
          flex-direction: column;

          .circle {
            width: 1rem;
            height: 1rem;
            background-color: #7b0000;
            border-radius: 20px;
            margin-top: 19.4rem;
          }
        }

        .developLoopFrame {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          width: 96%;

          // 循环
          .developLoop {
            margin: 1rem 0.1rem;
            padding: 0.2rem;
            overflow: hidden;
            width: 45%;
            background-color: #cfcccc;

            .developLoopImg {
              height: 50%;
              margin: 0.4rem;
            }

            .developLoopTitle {
              margin-left: 0.5rem;
              font-weight: bold;
              font-size: 1.5rem;
              color: #7b0000;
            }

            .developLoopContent {
              margin-left: 0.5rem;
              font-size: 0.8rem;
              color: black;
              font-weight: bold;
            }
          }

          // 文字
          .propaganda {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 40%;

            .propagandaChild {
              height: 50%;

              .propagandaChild1 {
                font-size: 2rem;
                font-weight: bold;
              }

              .propagandaChild2 {
                font-size: 1.2rem;
              }

              .propagandaChild3 {
                font-size: 1.2rem;
                font-weight: bold;
              }
            }
          }
        }
      }
    }

    // 企业文化
    .corporateCulture {
      display: flex;
      flex-direction: column;
      width: 100%;

      .corporateCultureContent {
        width: 100%;
        height: 40vh;

        .corporateCultureContentImg {
          height: 60%;
          width: 100%;
        }

        .corporateCultureContentImg1 {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 54%;

          //  企业愿景
          .enterpriseVisionFrame {
            height: 14vh;
            width: 100%;
            position: absolute;
            z-index: 3;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #fff;

            .cultureFont {
              font-size: 1.2rem;
              font-weight: bold;
              letter-spacing: 2px;
            }

            .cultureFont1 {
              margin-top: 0.2rem;
              font-size: 0.5rem;
            }
          }

          .cultureChild {
            top: 1rem;
            position: relative;
            height: 65%;
            width: 90%;
          }

          .cultureChild1 {
            height: 35%;
            width: 100%;
            background-color: rgb(179, 108, 108);
          }
        }
      }
    }

    // 企业资质
    .qualifications {
      .qualificationsContent {
        display: flex;
        flex-direction: column;

        .responsibility {
          display: flex;
          flex-direction: column;

          .responsibilityTitle {
            margin-left: 1rem;
            padding-left: 0.5rem;
            border-left: 2px solid #7b0000;
            letter-spacing: 1.5px;
            font-size: 1.2rem;
          }

          .responsibilityImg {
            margin: 1rem 0.2rem;
            height: 22vh;
          }
        }

        .governmentCare {
          display: flex;
          flex-direction: column;

          .governmentCareTitle {
            margin-left: 1rem;
            padding-left: 0.5rem;
            border-left: 2px solid #7b0000;
            letter-spacing: 1.5px;
            font-size: 1.2rem;
          }

          .governmentCareContent {
            height: 30vh;

            .governmentCareContentImg {
              top: 1rem;
              position: relative;
              margin: 0 0.3rem;
              display: flex;
              justify-content: space-between;
              height: 18vh;

              .governmentCareContentImgChild {
                height: 90%;
                width: 60%;
              }

              .governmentCareContentImgChild1 {
                height: 90%;
                width: 40%;
              }
            }

            .governmentCareContentBg {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 50%;
              width: 100%;
              background-color: #7b0000;
              color: #fff;
              font-size: 0.9rem;

              .governmentCareContentFont {
                height: 50%;
                width: 90%;
              }
            }
          }
        }
      }
    }
  }

  .IntroduceTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 10vh;

    .IntroduceTitleBg {
      height: 65%;
      width: 30%;
      background-color: rgb(179, 108, 108);
    }

    .IntroduceTitleFont {
      z-index: 3;
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #7b0000;
      flex-wrap: nowrap;
      display: flex;
      width: 100%;

      .IntroduceTitleFontChild {
        font-weight: bold;
        font-size: 1.3rem;
      }

      .IntroduceTitleFontChild1 {
        font-size: 0.5rem;
        border: 1px solid #bbbbbb;
        height: 15px;
        line-height: 15px;
        padding: 0 6px;
        border-radius: 30px;
        position: relative;
      }
    }
  }
}
.video-js {
  width: 100%;
  height: 230px;
}
video {
  object-fit: scale-down;
}
</style>



// WEBPACK FOOTER //
// src/components/iphone/introduce.vue